export default __webpack_public_path__ + "static/media/3069.1745f14e.jpg";